console.log("Wally scripts loaded!");

function getAmpedCloseBtn() {
  try {
    const el = document
      .querySelector(".amped-wrapper")
      .shadowRoot.querySelector("#el_TYkWHDA0Bt");
    console.log("Amped Close Button:", el);
    el.setAttribute("data-wally-amped", "test");

    const iframeElement = document.querySelector(
      "#shopify-section-template--17673965928706__main > div > div > div > div.prose > section > iframe"
    );
    iframeElement.setAttribute("title", "customer help center");
  } catch (error) {
  }
}

function applyWallyFixes() {
  console.log("inside applyWallyFixes");

  // Heading Structure-H3
  try {
    var h3Element = document.querySelector(
      "#overlayDescription > div > div > div > div > h3"
    );
    if (h3Element) {
      var h1Element = document.createElement("h1");
      h1Element.innerHTML = h3Element.innerHTML;

      for (var i = 0; i < h3Element.attributes.length; i++) {
        var attr = h3Element.attributes[i];
        h1Element.setAttribute(attr.name, attr.value);
      }

      h3Element.parentNode.replaceChild(h1Element, h3Element);
    }
  } catch (error) {
  }

  // Heading Structure-H4
  try {
    var h4Element = document.querySelector(
      "#rebuy-widget-98458 > div > div > h4"
    );
    if (h4Element) {
      var h2Element = document.createElement("h2");
      h2Element.innerHTML = h4Element.innerHTML;

      for (var i = 0; i < h4Element.attributes.length; i++) {
        var attr = h4Element.attributes[i];
        h2Element.setAttribute(attr.name, attr.value);
      }

      h4Element.parentNode.replaceChild(h2Element, h4Element);
    }
  } catch (error) {
  }

  // pages/reviews-1
  try {
    var elementScore = document.querySelector(
      "#yotpo-app > div > div > div.yotpo-bottomline-container > div.yotpo-bottom-line > div > div.yotpo-bottom-line-left-panel.yotpo-bottom-line-score"
    );
    var score = elementScore.innerText;
    var reviewEle = document.querySelector(
      "#yotpo-app > div > div > div.yotpo-bottomline-container > div.yotpo-bottom-line > div > div.yotpo-bottom-line-right-panel > div.yotpo-star-rating.yotpo-bottom-line-stars"
    );
    if (reviewEle) {
      reviewEle.setAttribute("role","group")
      reviewEle.setAttribute("aria-label", `Score ${score} out of 5`);
      var children = reviewEle.children;
      for (var i = 0; i < children.length; i++) {
        children[i].setAttribute("aria-hidden", "true");
      }
    }
  } catch (error) {
  }

  // pages-reviews-1 selected tab
  try {
    var elementSelected = document.querySelector(
      "#yotpo-app > div > div > div.ugc-storefront-widgets-tabs-container.yotpo-seo-page-tabs > div:nth-child(1)"
    );
    if (elementSelected) {
      if (elementSelected.className.includes("selected")) {
        elementSelected.setAttribute("aria-selected", "true");
      }
    }
  } catch (error) {
  }

  // star rating collections
  try {
    var eleStar = document.querySelector(
      "#product-list-template--17673964912898__main > product-card:nth-child(1) > div > div > div.product-card__info.empty\\:hidden > div.yotpo-widget-instance > div > div > div > div > div:nth-child(1)"
    );
    var children = eleStar.children;
    eleStar.setAttribute("aria-label", `Rating ${children.length} out of 5`);
    for (var i = 0; i < children.length; i++) {
      children[i].setAttribute("aria-hidden", "true");
    }
  } catch (error) {
  }

  // star rating collections
  try {
    var eleStar = document.querySelector(
      "#product-list-template--17673964912898__main > product-card:nth-child(2) > div > div > div.product-card__info.empty\\:hidden > div.yotpo-widget-instance > div > div > div > div > div:nth-child(1)"
    );
    var children = eleStar.children;
    eleStar.setAttribute("aria-label", `Rating ${children.length} out of 5`);
    for (var i = 0; i < children.length; i++) {
      children[i].setAttribute("aria-hidden", "true");
    }
  } catch (error) {
  }

  // star rating collections
  try {
    var eleStar = document.querySelector(
      "#product-list-template--17673964912898__main > product-card:nth-child(3) > div > div > div.product-card__info.empty\\:hidden > div.yotpo-widget-instance > div > div > div > div > div:nth-child(1)"
    );
    var children = eleStar.children;
    eleStar.setAttribute("aria-label", `Rating ${children.length} out of 5`);
    for (var i = 0; i < children.length; i++) {
      children[i].setAttribute("aria-hidden", "true");
    }
  } catch (error) {
  }

  // star rating collections
  try {
    var eleStar = document.querySelector(
      "#product-list-template--17673964912898__main > product-card:nth-child(4) > div > div > div.product-card__info.empty\\:hidden > div.yotpo-widget-instance > div > div > div > div > div:nth-child(1)"
    );
    var children = eleStar.children;
    eleStar.setAttribute("aria-label", `Rating ${children.length} out of 5`);
    for (var i = 0; i < children.length; i++) {
      children[i].setAttribute("aria-hidden", "true");
    }
  } catch (error) {
  }

  // star rating collections
  try {
    var eleStar = document.querySelector(
      "#product-list-template--17673964912898__main > product-card:nth-child(5) > div > div > div.product-card__info.empty\\:hidden > div.yotpo-widget-instance > div > div > div > div > div:nth-child(1)"
    );
    var children = eleStar.children;
    eleStar.setAttribute("aria-label", `Rating ${children.length} out of 5`);
    for (var i = 0; i < children.length; i++) {
      children[i].setAttribute("aria-hidden", "true");
    }
  } catch (error) {
  }

  // star rating collections
  try {
    var eleStar = document.querySelector(
      "#product-list-template--17673964912898__main > product-card:nth-child(6) > div > div > div.product-card__info.empty\\:hidden > div.yotpo-widget-instance > div > div > div > div > div:nth-child(1)"
    );
    var children = eleStar.children;
    eleStar.setAttribute("aria-label", `Rating ${children.length} out of 5`);
    for (var i = 0; i < children.length; i++) {
      children[i].setAttribute("aria-hidden", "true");
    }
  } catch (error) {
  }

  // star rating collections
  try {
    var eleStar = document.querySelector(
      "#product-list-template--17673964912898__main > product-card:nth-child(7) > div > div > div.product-card__info.empty\\:hidden > div.yotpo-widget-instance > div > div > div > div > div:nth-child(1)"
    );
    var children = eleStar.children;
    eleStar.setAttribute("aria-label", `Rating ${children.length} out of 5`);
    for (var i = 0; i < children.length; i++) {
      children[i].setAttribute("aria-hidden", "true");
    }
  } catch (error) {
  }

  // star rating collections
  try {
    var eleStar = document.querySelector(
      "#product-list-template--17673964912898__main > product-card:nth-child(8) > div > div > div.product-card__info.empty\\:hidden > div.yotpo-widget-instance > div > div > div > div > div:nth-child(1)"
    );
    var children = eleStar.children;
    eleStar.setAttribute("aria-label", `Rating ${children.length} out of 5`);
    for (var i = 0; i < children.length; i++) {
      children[i].setAttribute("aria-hidden", "true");
    }
  } catch (error) {
  }
  // Redundant h2 removed
  try {
    var h2Element = document.querySelector(
      "#shopify-section-template--17673966027010__stage_ten_player_Vh4kKE > div:nth-child(1) > h2"
    );
    if (h2Element) {
      h2Element.remove();
    }
  } catch (error) {}
}

function customerHelpCenter() {
  //color contrast - not working
  try {
    var ele = document.querySelector(
      "#__next > div > div.ghc-main-wrapper.ghc-embedded.css-lb0zu0.e7zpaoq8 > div.css-1p3loa1.epkclfx2 > div > div.css-uuifej.ee9tws30 > div > div.banner-text.css-j7p812.epkclfx0"
    );
    if (ele) {
      ele.style.color = "black";
    }
  } catch (error) {
  }

  // iframe title
  try {
    var iframeEle = document.querySelector("#\\36 1245ay7");
    if (iframeEle) {
      iframeEle.setAttribute("title", "Customer Help Center");
    }
  } catch (error) {}
}
function pagesLive() {
  //pageslive Not working
  try {
    var buttonEle = document.querySelector(
      "#__next > div > div > main > section.sc-eYRYVN.dbzRUY > div > div > div.sc-jXkspL.dpvmMY > button"
    );
  } catch (error) {}

  try {
    var yotpoEle = document.querySelector(
      "#yotpo-seo-reviews-container > div > div:nth-child(2) > div.yotpo-review-votes-icons-wrapper > div:nth-child(1)"
    );
  } catch (error) {}
}

function products() {
  // products page-ratings
  try {
    var eleStar = document.querySelector(
      "#shopify-section-template--17673966452994__main > div > div > div > safe-sticky > div > div:nth-child(2) > div > div > div > div > div > div > div:nth-child(1)"
    );
    if (eleStar) {
      var children = eleStar.children;
      eleStar.setAttribute("aria-label", `Rating ${children.length} out of 5`);
      for (var i = 0; i < children.length; i++) {
        children[i].setAttribute("aria-hidden", "true");
      }
    }
  } catch (error) {
  }
  //product-page-rating
  try {
    var eleStar = document.querySelector(
      "#shopify-section-template--17673966420226__main > div > div > div > safe-sticky > div > div:nth-child(3) > div > div > div > div > div > div.yotpo-sr-bottom-line-summary > div:nth-child(1)"
    );
    if (eleStar) {
      var children = eleStar.children;
      eleStar.setAttribute('role','group')
      eleStar.setAttribute("aria-label", `Rating ${children.length} out of 5`);
      for (var i = 0; i < children.length; i++) {
        children[i].setAttribute("aria-hidden", "true");
      }
    }
  } catch (error) {
  }
  //product-svg
  try {
    var svgEle = document.querySelector(
      "#yotpo-star-rating-reviews-summary > span.yotpo-star-rating-reviews-summary-icon > svg"
    );
    if (svgEle) {
      svgEle.setAttribute("aria-hidden", true);
    }
  } catch (error) {}

  // products Structure-H3->H2
  try {
    var h3Element = document.querySelector(
      "#rebuy-widget-129558 > div > div > h3"
    );
    if (h3Element) {
      var h2Element = document.createElement("h2");
      h2Element.innerHTML = h3Element.innerHTML;

      for (var i = 0; i < h3Element.attributes.length; i++) {
        var attr = h3Element.attributes[i];
        h2Element.setAttribute(attr.name, attr.value);
      }

      h3Element.parentNode.replaceChild(h2Element, h3Element);
    }
  } catch (error) {
  }

  // products Structure-H4->H3
  try {
    var h4Element = document.querySelector(
      "#rebuy-widget-87900 > div > div > h4"
    );
    if (h4Element) {
      var h3Element = document.createElement("h3");
      h3Element.innerHTML = h4Element.innerHTML;

      for (var i = 0; i < h4Element.attributes.length; i++) {
        var attr = h4Element.attributes[i];
        h3Element.setAttribute(attr.name, attr.value);
      }

      h4Element.parentNode.replaceChild(h3Element, h4Element);
    }
  } catch (error) {
  }
  // products anchor tag
  try {
    var anchorEle = document.querySelector(
      "#rebuy-widget-121921 > div > div > div.rebuy-product-grid.large-style-grid.large-columns-1.medium-style-grid.medium-columns-1.small-style-grid.small-columns-1 > div > div.rebuy-product-info > a"
    );
    if (anchorEle) {
      anchorEle.setAttribute("aria-hidden", "true");
    }
  } catch (error) {}

  // product checkbox-1  not working
  try {
    var checkboxEle1 = document.querySelector(
      "#rebuy-widget-129558 > div > div > div > div.rebuy-bundle__items > div.rebuy-product-block.cell-forte-serum-with-biomsc-human-stem-cell-conditioned-media.product-id-8097920221442.cart-has-item.tag-subscribe-and-save.tag-subscriptionupsell.is-input-product.is-selected > div > div.rebuy-product-checkbox > label > input"
    );
    if (checkboxEle1) {
      checkboxEle1.setAttribute(
        "aria-label",
        "Cell Forté Serum | Peptides | Exosomes"
      );
    }
  } catch (error) {}
  // product checkbox-2  not working
  try {
    var checkboxEle2 = document.querySelector(
      "#rebuy-widget-129558 > div > div > div > div.rebuy-bundle__items > div.rebuy-product-block.angela-caglia-daily-botanical-serum.product-id-4354196701316.cart-has-item.tag-subscribe-and-save.is-selected > div > div.rebuy-product-checkbox > label > input"
    );
    if (checkboxEle2) {
      checkboxEle2.setAttribute(
        "aria-label",
        "Daily Botanical Serum | Organic Face Oil"
      );
    }
  } catch (error) {}
}

function search() {
  // search label
  try {
    var searchBar = document.querySelector(
      "#rebuy-smart-search-results-sidebar > div.rebuy-smart-search__header-section.rebuy-smart-search-results-sidebar__header-section > div.rebuy-smart-search__input-section.rebuy-smart-search-results-sidebar__input-section > label"
    );
    if (searchBar) {
      var divELe = document.createElement("div");
      divELe.innerHTML = searchBar.innerHTML;

      for (var i = 0; i < searchBar.attributes.length; i++) {
        var attr = searchBar.attributes[i];
        divELe.setAttribute(attr.name, attr.value);
      }
      searchBar.parentNode.replaceChild(divELe, searchBar);
    }
  } catch (error) {
  }
  // radio1
  try {
    var radioEle1 = document.querySelector(
      "#rebuy-smart-search-results-sidebar > div.rebuy-smart-search__main-section.rebuy-smart-search-results-sidebar__main-section > div.rebuy-smart-search__filter-section.rebuy-smart-search-results-sidebar__filter-section > div > ul > li:nth-child(1) > div > div.rebuy-smart-search-results-sidebar__filter-list-body > ul > li:nth-child(1) > label > input"
    );
    if (radioEle1) {
      radioEle1.setAttribute("aria-label", "radio input");
    }
  } catch (error) {}
  // radio2
  try {
    var radioEle2 = document.querySelector(
      "#rebuy-smart-search-results-sidebar > div.rebuy-smart-search__main-section.rebuy-smart-search-results-sidebar__main-section > div.rebuy-smart-search__filter-section.rebuy-smart-search-results-sidebar__filter-section > div > ul > li:nth-child(1) > div > div.rebuy-smart-search-results-sidebar__filter-list-body > ul > li:nth-child(2) > label > input"
    );
    console.log("radioEle2", radioEle2);
    if (radioEle2) {
      radioEle2.setAttribute("aria-label", "radio input");
    }
  } catch (error) {}
}

function homePage() {
  try{
    var curreElement = document.querySelector("#shopify-section-sections--17673960292610__header > height-observer > x-header > nav.header__secondary-nav > div > div > button")
    if(curreElement){
      curreElement.setAttribute('aria-label','Currency Dropdown')
    }
  }
  catch(error){
    
  }
  try{
    var curreElement = document.querySelector("#shopify-section-sections--17673960194306__footer > div > div > div > div.footer__aside > div.localization-selectors > div > button")
    if(curreElement){
      curreElement.setAttribute('aria-label','Currency Dropdown')
    }
  }
  catch(error){
    
  }
  try{
    var curreElement = document.querySelector("#sidebar-menu > div > div.header-sidebar__footer > div > div > button")
    if(curreElement){
      curreElement.setAttribute('aria-label','Currency Dropdown')
    }
  }
  catch(error){
    
  }
  try{
    var curreElement = document.querySelector("#country_code")
    if(curreElement){
      curreElement.setAttribute('aria-label','Currency Dropdown')
    }
  }
  catch(error){
    
  }
  try{
    var element = document.querySelector('#shopify-section-template--17673966420226__main > div > div > div > safe-sticky > div > div:nth-child(9) > div > p:nth-child(7) > strong > span > a');
    
    if (element) {
      
        element.removeAttribute('title');
    
  }
  }
  catch(error){
}
  
}
setTimeout(getAmpedCloseBtn, 3000);
document.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(applyWallyFixes, 5000);
  setTimeout(customerHelpCenter, 12000);
  setTimeout(pagesLive, 10000);
  setTimeout(products, 5000);
  setTimeout(search, 5000);
  setTimeout(homePage,5000)
});
